import { useParams } from 'react-router-dom';
import { params } from 'routes';

export function useIdFromSlug() {
  const { managedContractSlug } = useParams<keyof params>();
  // url is built like so: "base_url/item/{offeringName}-{offeringId}/{claimKey}"
  // offering.slug = offeringName-offeringId
  return managedContractSlug?.split('-').at(-1);
}
